import style from "./spinner.scss";

const Spinner = () => (
    <div className={`${style.spinnerContainer}`}>
        <img className={style.spinnerIcon} src={'/assets/loading-primary.svg'} alt={'icon-btn'}/>
    </div>
);

export default Spinner;
